import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import Properties360Service from '@/services/services/properties360.service';
import Technician from '@/store/modules/technicians/model';
import TechniciansService from '@/services/services/technicians.service';

function getOnCallTechIds(res) {
  const onCallTechIds = [];
  if (res) {
    res
      .toString()
      .split('#')
      .forEach((tech) => onCallTechIds.push(parseInt(tech.split('@')[0])));
  }
  return onCallTechIds;
}

function getOnCallTechnicians(techs, type, values1, values2) {
  const onCallTechns = [];
  if (values1) {
    techs.forEach((tech) => {
      if (type === 1) {
        techs.indexOf(tech) > 3 && techs.indexOf(tech) <= 3 + values1
          ? onCallTechns.push(tech)
          : '';
      } else {
        techs.indexOf(tech) > 3 + values2 && techs.indexOf(tech) <= 3 + values1
          ? onCallTechns.push(tech)
          : '';
      }
    });
  }
  return onCallTechns;
}

const TechniciansResponsibleService = {
  async getTechnicians(propertyId) {
    return Properties360Service.getCurrent(propertyId).then((property) => {
      const array = [
        property.mnt_resp_technician_per_num,
        property.maintenance.tech_in_charge_per_num,
        property.mnt_resp_buddy_per_num,
        property.mnt_recourse_technician_per_num,
      ];
      // comptabilise le nombre de tech d'astreinte
      var listOnCallNumber = 0;
      // comptabilise le nombre de tech d'astreinte + en fin d'astreinte
      var listOnCallEndNumber = 0;
      getOnCallTechIds(property.on_call_per_num_list).forEach((id) => {
        array.push(id);
        listOnCallNumber = listOnCallNumber + 1;
      });
      listOnCallEndNumber = listOnCallNumber;
      getOnCallTechIds(property.on_call_end_per_num).forEach((id) => {
        array.push(id);
        listOnCallEndNumber = listOnCallEndNumber + 1;
      });

      if (listOnCallEndNumber === listOnCallNumber) {
        listOnCallEndNumber = 0;
      }

      return Promise.all(
        array.map((num) => {
          if (num) {
            return TechniciansService.getCurrent(num)
              .catch(errorHandler)
              .catch(() => new Technician({}));
          }
          return Promise.resolve(new Technician({}));
        })
      ).then((responses) => ({
        mntResponsibleTech: responses[0],
        techInCharge: responses[1],
        mntResponsibleTechBuddy: responses[2],
        mntRecourseTech: responses[3],
        onCallTechs: getOnCallTechnicians(
          responses,
          1,
          listOnCallNumber,
          listOnCallNumber
        ),
        onCallEndTechs: getOnCallTechnicians(
          responses,
          2,
          listOnCallEndNumber,
          listOnCallNumber
        ),
      }));
    });
  },
};

export default TechniciansResponsibleService;
